export const messageDataType = {
  TEXT: 'TEXT',
};
